exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#MathJax-Element-1-Frame #MathJax-Span-1 {\n  width: 100% !important;\n  overflow-x: auto; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/layout/pieces/Formula/index.scss
// module id = 966
// module chunks = 0